var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _vm.showPopup
        ? _c("gcicPopup", {
            on: {
              close: function($event) {
                _vm.showPopup = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("img", {
        staticClass: "gcic-logo",
        attrs: { src: require("../assets/gcicLogo.png") }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-10 col-md-offset-1" }, [
        _c("p", [_vm._v("Please edit or complete the following fields.")]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "form-group col-md-6" }, [
            _c("div", { staticClass: "form-group input-group" }, [
              _vm._m(1),
              _vm._v(" "),
              _c("input", {
                staticClass: "form-control",
                attrs: {
                  type: "username",
                  placeholder: "Provider Name",
                  required: ""
                },
                domProps: {
                  value: _vm.$store.getters.getEditedProviderValueByKeyChain([
                    "name"
                  ])
                },
                on: { input: _vm.setName }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group col-md-6" }, [
            _c("div", { staticClass: "form-group input-group" }, [
              _vm._m(2),
              _vm._v(" "),
              _c(
                "select",
                {
                  staticClass: "form-control",
                  staticStyle: {
                    margin: "0px",
                    "border-top-left-radius": "0px"
                  },
                  attrs: { required: "" },
                  domProps: {
                    value: _vm.$store.getters.getEditedProviderValueByKeyChain([
                      "year_founded"
                    ])
                  },
                  on: { input: _vm.setDate }
                },
                [
                  _c("option", { domProps: { value: null } }, [
                    _vm._v("Select year")
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.yearRange, function(year) {
                    return _c("option", [_vm._v(_vm._s(year))])
                  })
                ],
                2
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group col-md-12" }, [
            _c("div", { staticClass: "form-group input-group" }, [
              _vm._m(3),
              _vm._v(" "),
              _c("input", {
                staticClass: "form-control",
                attrs: {
                  type: "url",
                  oninvalid:
                    "setCustomValidity('Enter a valid URL beginning with http or https.')",
                  placeholder: "https://example.com",
                  required: ""
                },
                domProps: {
                  value: _vm.$store.getters.getEditedProviderValueByKeyChain([
                    "url"
                  ])
                },
                on: { input: _vm.setUrl }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group col-md-12" }, [
            _c("span", [_vm._v("Description*")]),
            _vm._v(" "),
            _vm._m(4),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "form-group input-group",
                staticStyle: { width: "100%" }
              },
              [
                _c("textarea", {
                  staticClass: "form-control",
                  staticStyle: { "border-radius": "5px" },
                  attrs: {
                    type: "text",
                    rows: "7",
                    maxlength: "10000",
                    minlength: "200",
                    required: ""
                  },
                  domProps: {
                    value: _vm.$store.getters.getEditedProviderValueByKeyChain([
                      "description"
                    ])
                  },
                  on: { input: _vm.setDesc }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group col-md-6" }, [
            _c("div", { staticClass: "form-group input-group" }, [
              _vm._m(5),
              _vm._v(" "),
              _c("input", {
                staticClass: "form-control",
                attrs: { type: "email", placeholder: "Email Address" },
                domProps: {
                  value: _vm.$store.getters.getEditedProviderValueByKeyChain([
                    "email"
                  ])
                },
                on: { input: _vm.setEmail }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group col-md-6" }, [
            _c("div", { staticClass: "form-group input-group" }, [
              _vm._m(6),
              _vm._v(" "),
              _c("input", {
                staticClass: "form-control",
                attrs: {
                  type: "tel",
                  pattern: "[0-9]{3}-[0-9]{2}-[0-9]{3}",
                  placeholder: "Phone Number"
                },
                domProps: {
                  value: _vm.$store.getters.getEditedProviderValueByKeyChain([
                    "phone_number"
                  ])
                },
                on: { input: _vm.setPhoneNumber }
              })
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-12" },
            [
              _c("img", {
                staticStyle: { "margin-bottom": "4px" },
                attrs: {
                  height: "100px",
                  "v-if": _vm.$store.getters.getEditedProviderValueByKeyChain([
                    "logo"
                  ]),
                  src: _vm.$store.getters.getEditedProviderValueByKeyChain([
                    "logo"
                  ])
                }
              }),
              _vm._v(" "),
              _c(
                "filestack",
                {
                  attrs: { apikey: _vm.apikey, options: _vm.options },
                  on: { success: _vm.onSuccess }
                },
                [
                  _c("button", { staticClass: "btn btn-create" }, [
                    _vm._v("\n            Upload logo\n          ")
                  ])
                ]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("hr", {
          staticStyle: { "margin-top": "20px", "margin-bottom": "20px" }
        }),
        _vm._v(" "),
        _c(
          "form",
          {
            on: {
              submit: function($event) {
                $event.preventDefault()
              }
            }
          },
          [_c("contacts")],
          1
        ),
        _vm._v(" "),
        _c("hr", {
          staticStyle: { "margin-top": "20px", "margin-bottom": "20px" }
        }),
        _vm._v(" "),
        _c("h4", [_vm._v("Deals")]),
        _vm._v(" "),
        _c("p", [_vm._v("Please add any deals you have been involved in.")]),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "button",
              {
                staticClass: "btn-default btn-create",
                staticStyle: { "margin-top": "0px", "margin-left": "0px" },
                attrs: { type: "button" },
                on: { click: _vm.createNewDeal }
              },
              [_vm._v("\n        Create new deal\n      ")]
            ),
            _vm._v(" "),
            _vm._l(_vm.deals, function(deal, index) {
              return _c(
                "div",
                [
                  _c("hr", { staticStyle: { "margin-top": "20px" } }),
                  _vm._v(" "),
                  _c("inputForm", { key: index, attrs: { index: index } })
                ],
                1
              )
            })
          ],
          2
        ),
        _vm._v(" "),
        _c("hr", {
          staticStyle: { "margin-top": "20px", "margin-bottom": "20px" }
        }),
        _vm._v(" "),
        _c("h4", [_vm._v("Key Facts")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Please fill out the fields below about your investment approach."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "col-md-12" },
                [
                  _c("keyStats", {
                    attrs: {
                      show: [
                        "minimumInvestment",
                        "maximumInvestment",
                        "avgAmountRaised",
                        "femaleFocus"
                      ]
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-12" },
                [_c("keyDescs", { attrs: { show: ["applicationProcess"] } })],
                1
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "form",
          {
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.submit($event)
              }
            }
          },
          [_c("saveButton")],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("small", [_c("i", [_vm._v("*required")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "input-group-addon",
        staticStyle: { background: "white" }
      },
      [_c("span", [_vm._v("Name*")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "input-group-addon",
        staticStyle: { background: "white" }
      },
      [_c("span", [_vm._v("Year Founded*")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "input-group-addon",
        staticStyle: { background: "white" }
      },
      [_c("span", [_vm._v("URL*")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("small", [_c("i", [_vm._v("(200 - 1000 characters)")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "input-group-addon",
        staticStyle: { background: "white" }
      },
      [_c("span", [_vm._v("Email")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "input-group-addon",
        staticStyle: { background: "white" }
      },
      [_c("span", [_vm._v("Phone Number")])]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-eaca9f96", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eaca9f96","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gcicPage.vue
// module id = 214
// module chunks = 0